import React, { useState } from 'react'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  TableHead,
} from '@mui/material'
import { TablePaginationActions } from './TablePaginationActions'
import { LoadingSkeletonRows } from './LoadingSkeletonRows'
import moment from 'moment'
import ErrorMessage from '../../component/shared/component/ErrorMessage'

export const PurchaseHistory = ({
  data = [],
  isLoading,
  additionalInfo = [],
  hiddenColumns = [],
}) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  // Drop invalid rows — an htg company with no actual orders comes back with empty fields
  // and would otherwise render as blank columns. If nothing's left, the empty state shows.
  const validData = data.filter((row) => row.itemId)

  const arr =
    rowsPerPage > 0
      ? validData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      : validData

  const columns = [
    { label: 'Item ID', id: 'itemId' },
    { label: 'Invoice ID', id: 'invoiceId' },
    {
      label: 'Order Date',
      id: 'orderDate',
      view: (row) => moment(row.orderDate).format('DD/MM/YY'),
    },
    {
      label: 'Invoice Date',
      id: 'invoiceDate',
      view: (row) => moment(row.invoiceDate).format('DD/MM/YY'),
    },
    { label: 'Unit Price', id: 'unitPrice' },
    { label: 'Amount', id: 'amount' },
    { label: 'Discount', id: 'discount' },
    { label: 'Quantity', id: 'orderQuantity' },
    ...additionalInfo,
    { label: 'Point', id: 'point' },
  ].filter((col) => !hiddenColumns.includes(col.id))

  if (arr.length === 0 && !isLoading)
    return (
      <Paper>
        <ErrorMessage empty message={'No result to display'} />
      </Paper>
    )

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 500 }} aria-label='custom pagination table'>
        <TableHead>
          <TableRow>
            {columns.map((col) => (
              <TableCell key={col.id}>{col.label}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <LoadingSkeletonRows rows={10} length={columns.length} />
          ) : (
            arr.map((row, idx) => (
              <TableRow key={idx}>
                {columns.map((col) => (
                  <TableCell key={col.id}>{col.view ? col.view(row) : row[col.id]}</TableCell>
                ))}
              </TableRow>
            ))
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[10, 20, 30, { label: 'All', value: -1 }]}
              colSpan={columns.length}
              count={validData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{ inputProps: { 'aria-label': 'rows per page' }, native: true }}
              onPageChange={(event, newPage) => {
                setPage(newPage)
              }}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10))
                setPage(0)
              }}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  )
}
